// extracted by mini-css-extract-plugin
export default {"root":"_2PIRA","small":"_3K54i","normal":"_13NmM"};